import Image from "next/image"

import _ from 'lodash'

import { Header, HeaderShim } from "../fuselage/global/header/header"
import { IntroHero } from "../fuselage/blocks/intro-hero/intro-hero"
import { IntroUnit, IntroUnitTitle, IntroUnitBody } from '../fuselage/blocks/intro-unit/intro-unit'
import { ArrowButton } from "../fuselage/components/arrow-button/arrow-button"
import { QuoteGrid, QuoteImage, Quote, QuoteGridSpacer } from "../fuselage/layout/quote-grid/quote-grid"
import { ScrollTicker } from "../fuselage/blocks/scroll-ticker/scroll-ticker"
import { Button } from "../fuselage/components/button/button"
import HubspotForm from "../fuselage/components/hubspot-form/hubspot-form"

import { GetBizzaboPartersByLevel } from '../lib/bizzabo-partner-levels'
import { ColorGlow } from "../fuselage/theme/color-glow/color-glow"

export default function SponsoringIdeea ({ partnerData }) {

    return (
        <>

            <HeaderShim />

            <IntroHero 
                hero={{ src: '/assets/img/sponsoring-ideea.jpg', width: 1920, height: 840 }} 
                heroMobile={{ src: '/assets/img/sponsoring-ideea-mobile.jpg', width: 800, height: 800 }} 
            />

            <IntroUnit overlapHero>
                <IntroUnitTitle>
                    <div className="formatted">
                        <p className="fs-0 fw-600 lh-1">Sponsoring IDEEA 2022</p>
                        <div className="mt-sm">
                            <p>
                                <ArrowButton href={`/sponsor-ideea`} large inverse>
                                    Become a sponsor
                                </ArrowButton>
                            </p>
                        </div>
                    </div>
                </IntroUnitTitle>

                <IntroUnitBody>
                    <div className="fw-300">
                        <p>The hospitality sector in Southeast Europe offers unrivalled opportunities for new hospitality developments in terms of greater sustainability, resilience, and innovation. With hotel bookings and investors appetites improving, those seeking to be part of the growing opportunities must shine the spotlight on themselves and step forward to be part of the conversations with those operating in the region.</p>
                        <p>With focused discussions on opportunities in Southeast Europe, the IDEEA Hospitality Investment Forum will be home to any organisation committed to driving regional growth and looking to showcase its brand and expertise. Our branded opportunities and experiences will provide an unfair advantage to engage, educate, captivate, and collaborate with an audience shaping the future of hospitality in the region.</p>
                    </div>
                </IntroUnitBody>
            </IntroUnit>



            {/* what to achieve */}

            <section className="block">
                <div className="container maxw-60">
                    <p className="fs-0 fw-800 caps c-black center-desktop">What you can expect to achieve at IDEEA 2022</p>
                </div>
                
                <div className="container columns-2 center-desktop gap-md maxw-60">
                    <section>
                        <p><Image src={`/assets/icons/map.svg`} width={120} height={120} alt={`sponsoring`} /></p>
                        <p className="fs-3 fw-600 lh-1 h c-black">Strategically position your brand</p>
                        <p>Bring your brand to life and create a continuous narrative through brilliant multi-platform campaigns to build brand recognition and drive engagement with a curated audience pre, during, and post-event.</p>
                    </section>

                    <section>
                        <p><Image src={`/assets/icons/ff.svg`} width={120} height={120} alt={`sponsoring`} /></p>
                        <p className="fs-3 fw-600 lh-1 h c-black">Accelerate results</p>
                        <p>Leverage the momentum of the event promotions to announce new products, expand brand awareness, and gain instant traction throughout the entire hospitality investment ecosystem.</p>
                    </section>

                    <section>
                        <p><Image src={`/assets/icons/handshake.svg`} width={120} height={120} alt={`sponsoring`} /></p>
                        <p className="fs-3 fw-600 lh-1 h c-black">Build trust, face-to-face</p>
                        <p>In-person interactions allow you to build positive perceptions and trust with your potential prospects and clients that digital interactions can&apos;t match. It shows them that you are willing to invest in your relationships.</p>
                    </section>

                    <section>
                        <p><Image src={`/assets/icons/job-titles.svg`} width={120} height={120} alt={`sponsoring`} /></p>
                        <p className="fs-3 fw-600 lh-1 h c-black">Grow your community</p>
                        <p>On-site activities and sponsored experiences are great opportunities to grow your community, which enable you to continue the conversation through your platform and gain valuable feedback.</p>
                    </section>
                </div>
            </section>



            {/* partners */}

			<section className="block bg-default">
				<div className="container center-desktop formattet">
					<p className="fs-0 fw-800 caps c-black">Join our 2022 IDEEA <br/>Sponsors &amp; Partners</p>
					<p className="fs-5 maxw-50 mx-auto mt-sm">Thank you to our sponsors and partners whose support has been integral in gathering the hospitality investment community across Europe together to refocus on a new future.</p>
					<p className="mt-sm"><Button href='/sponsor-ideea' decal='fs-5 fw-600'>Become a sponsor</Button></p>
				</div>

				<div className="container">
					{ GetBizzaboPartersByLevel( 1, partnerData ) }
					{ GetBizzaboPartersByLevel( 2, partnerData ) }
					{ GetBizzaboPartersByLevel( 8, partnerData ) }
				</div>
			</section>



            {/* quotes */}

			<section className="bg-theme-blur c-white py-lg">

                <ScrollTicker speed={500}>Let&apos;s meet at #IDEEA  • Let&apos;s meet at #IDEEA  • Let&apos;s meet at #IDEEA  • Let&apos;s meet at #IDEEA </ScrollTicker>

                <QuoteGrid>

                    <QuoteGridSpacer/>

                    <QuoteImage  src={`/assets/img/quotes-01.jpg`} width={1200} height={900}/>

                    <Quote span={2}>
                        <p className="fs-3 fw-300 lh-2 maxw-30">This was probably one of the best and most productive conferences I have attended recently. It was the right size, and the calibre of the attendees was great. </p>
                        <p className="mt-xs"><span className="fw-600">Strategic Advisor</span><br/>Rosewood Hotel Group</p>
                    </Quote>
                    
                    <QuoteImage  src={`/assets/img/quotes-04.jpg`} width={1200} height={900}/>

                    <Quote>
                        <p className="fs-3 fw-300 lh-2">The quality of attendees, the quality of the panellists and the quality overall was superb. We can highly recommend this event.</p>
                        <p className="mt-xs"><span className="fw-600">Vice President, Business Development</span><br/>Radisson Hotel Group</p>
                    </Quote>

                    <QuoteImage  src={`/assets/img/quotes-05.jpg`} width={2000} height={1060} span={2} />

                    <QuoteGridSpacer/>

                    <QuoteImage  src={`/assets/img/quotes-02.jpg`} width={1200} height={1200}/>
                    
                    <QuoteImage  src={`/assets/img/quotes-03.jpg`} width={1200} height={900}/>

                    <Quote>
                        <p className="fs-3 fw-300 lh-2">It was an outstanding event. An opportunity to network with key players in the industry.</p>
                        <p className="mt-xs"><span className="fw-600">Director</span><br/>Schulze Global Investments</p>
                    </Quote>

                    <QuoteImage  src={`/assets/img/quotes-07.jpg`} width={2000} height={1060} span={2} />

                    <Quote span={2}>
                        <p className="fs-3 fw-300 lh-2">It&apos;s a great way for us to get to know people here on the ground, meet the people who have local expertise and that&apos;s a great way for us to source deals. Especially, as Principal Real Estate Europe is keen to invest here in the region and it&apos;s great opportunity for us to meet operators, people who actually know the market and will allow us to invest here in the region.</p>
                        <p className="mt-xs"><span className="fw-600">Transactions Manager, Hotel &amp; Leisure Division</span><br/>Principal Real Estate Europe</p>
                    </Quote>

                    <QuoteGridSpacer/>
                    
                    <Quote>
                        <p className="fs-3 fw-300 lh-2">It was a great event where I got the chance to meet industry peers as well as investors whom we can have future business opportunities with.</p>
                        <p className="mt-xs"><span className="fw-600">Development Analyst, Southeast Europe</span><br/>Accor</p>
                    </Quote>
                    
                    <QuoteImage  src={`/assets/img/quotes-06.jpg`} width={1200} height={900}/>

                </QuoteGrid>

                <ScrollTicker speed={500}>Join the community • Join the community • Join the community • Join the community</ScrollTicker>

                </section>



            {/* floorplan */}

            <section className="block">
                <div className="container">
                    <p className="fs-0 fw-800 caps c-black center-desktop">IDEEA 2022 floor plan</p>
                    <div className="mt-lg maxw-50 mx-auto bg-white rad-md">
                        <ColorGlow>
                            <div className="rad-md overflow-hidden">
                                <Image src={`/assets/img/floorplan.svg`} width={1750} height={1030} alt={`floorplan`} />
                            </div>
                        </ColorGlow>
                    </div>
                </div>
            </section>



            {/* form */}

			<section className="block bg-default">
				<div className="container center-desktop">
					<p className="fs-0 fw-800 caps c-black center-desktop">Become a sponsor at IDEEA 2022</p>
				</div>

				<div className="container maxw-70 columns-2 gap-md">
					<section className="formatted">
						<p className="fs-4">Let&apos;s partner together to bring your solutions, strategies, and expertise into the spotlight. Partnering with IDEEA allows you and your organisation to expand your reach and amplify your message. You will be connecting with an audience motivated to unlock the immense potential for hospitality investment and development in Southeast Europe.</p>
                        <p className="fs-4">If you want to elevate your market position and perception, we highly suggest connecting with our team to discuss be spoke opportunities. We&apos;re ready - are you? Let&apos;s talk!</p>
					</section>

					<section>
						<HubspotForm portalId={`14527187`} formId={`ce7a3b75-b1f3-49c0-9574-e5cdd57fb387`} />
					</section>
				</div>
			</section>



        </>
    )
}



export async function getStaticProps({ params, preview, previewData }) {
	
	const partners = await fetch(`https://api.bizzabo.com/api/partners?eventId=${process.env.BIZZABO_EVENT_ID}`, {
		"method": "GET",
		"headers": {
			"Content-Type": "application/json",
			"Authorization": "Bearer 67f61f9e-e897-4536-914e-3f47286650f9"
		}
	})
	const partnerData = await partners.json()

	
    return { 
		props: { 
			partnerData: partnerData.content
		}
	}
}